const fr = {
  "joinNow": {
    "who_are_you": {
      "pageTitle": "Adhérer maintenant",
      "title": "Qui es-tu? Nous aimerions mieux vous connaître.",
      "option": ['Créateur', 'Investisseur', 'Talent'],
      "nextButton": 'Suivante',
    },

    'create_new_account': {
      "pageTitle": "Créer un nouveau compte.",
      "titleA": "Viens rejoindre notre communauté ! Créons ton compte.",
      "titleB":"Vous en avez déjà un ?",
      "signinButton":"Connectez-vous ici",
      "lastText": "En soumettant le formulaire, vous acceptez nos.",
      "termsOfService": "Conditions d'utilisation",
      "nextButton": "Suivant",
      "OR": "OU",
      "form": {
        "email": "Email",
        "companyEmail": "Courriel de l'entreprise",
        "password": "Mot de passe",
        "name": "Nom complet",
        "userType": "Sélectionner le type d'utilisateur",
        "country": "Résidence",
        "companyName": "om de l'entreprise",
        "companyAddress": "Adresse de la société",
        "dob": "Date de naissance",
        "typeOptions": ["Investisseur individuel", "Organisation"],
        "role": "role",

      }
    }
  },
  "tagsView": {
    "project": {
      "pageTitle": "Par quel type de projets êtes-vous intéressé ?",
      "title": "Cela nous permettra de vous montrer les meilleures correspondances pour vos centres d'intérêt.",
      "tags":{
        'TV Drama': 'Drame télévisé',
        'Animations': 'Animations',
        'Other': 'Autre',
        'Indie Shorts': 'Shorts indépendants',
        'Feature Films': 'FLongs métrages',
        'Documentaries': 'Documentaires',
        'Anime':'Animé'
      }
    },
    "geography": {
      "pageTitle": "Dans quelles zones géographiques souhaitez-vous financer ?",
      "title": "Cela nous permettra de vous montrer les meilleures correspondances pour vos centres d'intérêt.",
      "tags":{
        'United Kingdom': 'Royaume-Uni',
        'India': 'Inde',
        'Nigeria': 'Nigéria',
        'Europe':  'Europe',
        'China': 'Chine',
        'South Korea': 'Corée du Sud',
        'United States':  'États-Unis',
        'Other': 'Autre'
      }
    },
    "nextButton": "Suivant",
    "backButton": "Retour",
    "label": "Balises"
  }
};
module.exports = fr;


